import Codewars from '../components/Codewars';
import Github from '../components/Github';
import Toffee from '../components/Toffee';

const Footer = () => {
    return (
        <div id='Footer'>
            <Codewars/>
            <Github/>
            <Toffee/>
        </div>
    )

}

export default Footer;